import React, {useEffect, useState} from "react"
import {ButtonV2} from "../../../../components/ui/ButtonsV2/ButtonV2";
import {useFileSelect} from "../../../../pages/siren/hooks/useFileSelect";
import {noop} from "../../../../lib/misc/noop";

type Props = {
    originalImageURL?: string;
    onChange?: (file: File  | undefined) => void;
}

export function ImageFileSelect({originalImageURL = "", onChange = noop}: Props) {

    const {
        selectedFile,
        invalidFile,
        fileInputRef,
        activateFileSelect,
        handleFileChange,
        fileUrl,
        accept,
    } = useFileSelect({
        allowedTypes: ["jpg", "jpeg", "png", "webp"]
    })

    const [image, setImage] = useState<string>();

    useEffect(() => {
        const file = selectedFile;
        if (!file) return;

        const url = URL.createObjectURL(file);
        setImage(url);
        onChange(file)
    }, [selectedFile]);

    return (
        <div className="flex flex-col gap-4">
            <input ref={fileInputRef} type="file" accept={accept} onChange={handleFileChange}
                   className={"hidden"}/>
            <ButtonV2 label={"Select Image File"} onClick={activateFileSelect}/>
            {selectedFile && image && (
                <>
                    <label>Selected File</label>
                    <img src={image} alt={"Selected Image"}/>
                </>
            )}
            {originalImageURL && (
                <>
                    <label>Current Image</label>
                    <img src={originalImageURL} alt={"Current Image"}/>
                </>
            )}
        </div>
    )


}